import React from 'react';
import classNames from 'classnames';
import FadeIn from 'react-fade-in';

//확인 버튼 모달 (버튼 한개)
export const AlertModal = (message, onClose, onClickClose, name, className) => {
  //
  return (
    <aside id="aside" style={{ display: 'flex', justifyContent: 'center' }}>
      <FadeIn>
        <div
          className={classNames('pop_style1', className && className)}
          style={{ display: 'block', marginTop: '350.5px' }}
        >
          <div className="pop_head">
            {/* <button className="pop_close" type="button" onClick={onClickClose}> */}
            {onClickClose === undefined ? (
              <button
                className="pop_close"
                type="button"
                onClick={() => {
                  onClose();
                }}
              >
                <span>close</span>
              </button>
            ) : (
              <button
                className="pop_close"
                type="button"
                onClick={() => {
                  onClickClose();
                  onClose();
                }}
              >
                <span>close</span>
              </button>
            )}
          </div>
          <div className="pop_content" style={{ whiteSpace: 'pre-wrap' }}>
            {message.message}
            <br />
            <p className="fz12px text_org mt20">{message.explain}</p>
          </div>
          <div className="pop_btnbox pop_btn_length2">
            {onClickClose === undefined ? (
              <button
                className="pop_btn_black pop_close"
                type="button"
                onClick={() => {
                  onClose();
                }}
              >
                <span>{name === undefined ? '확인' : name}</span>
              </button>
            ) : (
              <button
                className="pop_btn_black pop_close"
                type="button"
                onClick={() => {
                  onClickClose();
                  onClose();
                }}
              >
                <span>{name === undefined ? '확인' : name}</span>
              </button>
            )}
          </div>
        </div>
      </FadeIn>
    </aside>
  );
};

// 버튼 두개
export const ConfirmModal = (message, onClose, onOk, names, className, txtAlign, wide) => {
  //
  // message는 message: '', explanation:''으로 구성된 object
  // names는 cancelName: '', explanation: ''으로 구성된 object
  return (
    <aside id="aside" style={{ display: 'flex', justifyContent: 'center' }}>
      <FadeIn>
        <div
          className={classNames('pop_style1', className && className)}
          style={{ display: 'block', marginTop: '350.5px' }}
        >
          <div className="pop_head">
            <button className="pop_close" type="button" onClick={onClose}>
              <span>close</span>
            </button>
          </div>
          <div className="pop_content" style={{ whiteSpace: 'pre-wrap', textAlign: txtAlign || 'center' }}>
            {message.message}
            <br />
            <p className="fz13px text_org mt20">{message.explanation}</p>
          </div>
          <div className="pop_btnbox pop_btn_length2">
            <button
              className={classNames('pop_btn_white', 'pop_close', wide ? 'pop_btn_wide' : '')}
              type="button"
              onClick={onClose}
            >
              <span>{names === undefined ? '취소' : names.cancelName}</span>
            </button>
            <button
              className={classNames('pop_btn_black', 'pop_close', wide ? 'pop_btn_wide' : '')}
              type="button"
              onClick={() => {
                onClose();
                onOk();
              }}
            >
              <span>{names === undefined ? '확인' : names.okName}</span>
            </button>
          </div>
        </div>
      </FadeIn>
    </aside>
  );
};

// 버튼 세개
export const ConfirmModal3 = (message, onClose, onApply, onChange, names, className, txtAlign) => {
  //
  // message는 message: '', explain:''으로 구성된 object
  // names는 cancelName: '', okName: ''으로 구성된 object
  return (
    <aside id="aside" style={{ display: 'flex', justifyContent: 'center' }}>
      <FadeIn>
        <div
          className={classNames('pop_style1', className && className)}
          style={{ display: 'block', marginTop: '350.5px', width: '440px' }}
        >
          <div className="pop_head">
            <button className="pop_close" type="button" onClick={onClose}>
              <span>close</span>
            </button>
          </div>
          <div className="pop_content" style={{ whiteSpace: 'pre-wrap', textAlign: txtAlign || 'center' }}>
            {message.message}
            <br />
            <p className="fz12px text_org mt20">{message.explanation}</p>
          </div>
          <div className="pop_btnbox pop_btn_length2">
            <button className="pop_btn_white pop_close" type="button" onClick={onClose}>
              <span>{names === undefined ? '취소' : names.cancelName}</span>
            </button>
            <button
              className="pop_btn_black"
              type="button"
              onClick={() => {
                onClose();
                onApply();
              }}
            >
              <span>{names === undefined ? '적용' : names.applyName}</span>
            </button>
            <button
              className="pop_btn_black"
              type="button"
              onClick={() => {
                onClose();
                onChange();
              }}
            >
              <span>{names === undefined ? '확인' : names.changeName}</span>
            </button>
          </div>
        </div>
      </FadeIn>
    </aside>
  );
};

// 컨텐츠 모달 children을 받음
export const ContentsModal = (onClose, onOk, names, className, children, svcInfo) => {
  //
  return (
    <aside id="aside" style={{ display: 'flex', justifyContent: 'center' }}>
      <FadeIn>
        <div
          className={classNames('pop_style1', className && className)}
          style={{ display: 'block', marginTop: '350.5px' }}
        >
          <div className="pop_head">
            <button className="pop_close" type="button" onClick={onClose}>
              <span>close</span>
            </button>
          </div>
          <div className="pop_content">{children}</div>
          <div className="pop_btnbox pop_btn_length2">
            <button className="pop_btn_white pop_close" type="button" onClick={onClose}>
              <span> {names === undefined ? '취소' : names.cancelName}</span>
            </button>
            <button
              className="pop_btn_black pop_close"
              type="button"
              onClick={() => {
                onOk(svcInfo);
                onClose();
              }}
            >
              <span>{names === undefined ? '확인' : names.okName}</span>
            </button>
          </div>
        </div>
      </FadeIn>
    </aside>
  );
};
